<template>
  <div>
    <modal-layout-top :title="title" />

    <div class="content slider-modal">
      <label>PIN-kod</label>
      <input class="input" placeholder="PIN-kod" type="text" v-model="newPin" />
      <modal-layout-buttons :store-name="'users'" />
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'

export default {
  name: 'user-modal',
  data () {
    return {
      isUpdate: false,
      newPin: null
    }
  },
  components: {
    ModalLayoutTop,
    ModalLayoutButtons
  },
  computed: {
    title () {
      return `Ny PIN för ${this.user.initials}`
    }
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions('users', ['changePin']),
    closePanel (user) {
      this.$emit('closePanel', {
        user
      })
    },
    save () {
      this.changePin({ id: this.user.userId, newPin: this.newPin }).then(() => this.$emit('closePanel'))
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.save()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/UserPinModal.vue